import { createSlice } from '@reduxjs/toolkit'

export const configSlice = createSlice({
    name: 'config',
    initialState: {
        configs: {},
    },
    reducers: {
        setConfigs: (state, action) => {
            console.log(state)
            console.log(action)
            state.configs = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { setConfigs } = configSlice.actions

export default configSlice.reducer
